import { useEffect } from "react";

export default function useNoIndex(title) {
    useEffect(() => {
        const previousTitle = document.title;
        const metaName = "meta[name='robots'][data-fisp-tv-admin]";
        let meta = document.head.querySelector(metaName);

        if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", "robots");
            meta.setAttribute("data-fisp-tv-admin", "true");
            document.head.appendChild(meta);
        }

        meta.setAttribute("content", "noindex,nofollow,noarchive");
        document.title = title ? `${title} | FISP TV Admin` : "FISP TV Admin";

        return () => {
            document.title = previousTitle;
            if (meta?.parentNode) {
                meta.parentNode.removeChild(meta);
            }
        };
    }, [title]);
}
